import ensureError from '@/common/utils/error';
import { createApi } from '@reduxjs/toolkit/query/react';

export const tagTypes = [
  'User',
  'PendingInvite',
  'Organisations',
  'Students',
  'Groups',
  'Assessments',
  'PlacementTests',
  'LessonPlans',
  'WordMats',
  'LearnerNotes',
  'CustomLevels',
] as const;

export const orgTag = (type: (typeof tagTypes)[number], orgId: string) =>
  ({ type, id: `ORG:${orgId}` }) as const;

export const studentTag = (
  type: (typeof tagTypes)[number],
  studentId: string,
) =>
  ({
    type,
    id: `STUDENT:${studentId}`,
  }) as const;

export const idTag = (type: (typeof tagTypes)[number], id: string) =>
  ({ type, id }) as const;

export const appApi = createApi({
  reducerPath: 'appApi',
  baseQuery: async (queryResult: Promise<unknown>, { endpoint }) => {
    try {
      const data = (await queryResult) ?? null;
      return { data };
    } catch (e) {
      const error = ensureError(e);
      console.error(`[${endpoint}]`, error);
      return { error: { message: error.message } };
    }
  },
  tagTypes,
  endpoints: () => ({}), // defined per resource in app/redux/endpoints
});
